module.exports = __webpack_public_path__ + "img/cosmomo-recent-works.39e73486.png";